import React from "react";
import { useTranslation } from "react-i18next";
import useAppNavigate from "../../hooks/useAppNavigate";
import {
  dollars,
  transaction,
  scann,
  moree,
  hand,
} from "../../common/imagePath";

const ROW_HEIGHT = 40;
const INNER_PAD_TOP = 8;
const HAND_SIZE = 60;

const AppNavMockup = ({ activeRoute }) => {
  const navigate = useAppNavigate();
  const { t } = useTranslation();

  const NAV_ITEMS = [
    { icon: transaction, label: t("appNav.addTransaction"), route: "/how-to-add-transactions" },
    { icon: dollars,     label: t("appNav.setBudget"),      route: "/how-to-set-budget" },
    { icon: scann,       label: t("appNav.scanReceipt"),    route: "/how-to-scan-receipt" },
    { icon: moree,       label: t("appNav.more"),           route: null },
  ];

  const activeIndex = NAV_ITEMS.findIndex((item) => item.route === activeRoute);

  const handTop =
    INNER_PAD_TOP + activeIndex * ROW_HEIGHT + ROW_HEIGHT / 2 - HAND_SIZE / 2;

  return (
    <div className="mx-4 mb-6">
      <style>{`
        @keyframes handTap {
          0%   { transform: translateX(0)     scale(1);    }
          35%  { transform: translateX(-10px) scale(0.92); }
          55%  { transform: translateX(-6px)  scale(0.96); }
          100% { transform: translateX(0)     scale(1);    }
        }
      `}</style>

      {/* Outer frame */}
      <div className="border border-[#DEDEDE] dark:bg-[#1B1C1E] dark:border-[#1B1C1E] rounded-2xl p-6 relative overflow-visible">
        {/* Inner card */}
        <div className="bg-white dark:bg-[#121212] border border-transparent dark:border-[#2A2F3A] rounded-xl px-2 py-2 relative overflow-visible min-w-[200px]">
          {NAV_ITEMS.map((item, index) => {
            const isActive = item.route === activeRoute;
            return (
              <React.Fragment key={index}>
                <div
                  onClick={() => item.route && navigate(item.route)}
                  className={`flex items-center gap-3 px-3 py-2.5 rounded-xl transition-colors duration-200 ${
                    index !== NAV_ITEMS.length - 1 ? "mb-0.5" : ""
                  } ${isActive ? "bg-[#3479F7]" : ""} ${
                    item.route ? "cursor-pointer active:opacity-70" : ""
                  }`}
                >
                  <img
                    src={item.icon}
                    alt=""
                    className={`h-4 object-contain flex-shrink-0 ${isActive ? "brightness-0 invert" : ""}`}
                  />
                  <span
                    className={`text-sm font-semibold ${
                      isActive ? "text-white" : "text-[#1C1C1E] dark:text-white"
                    }`}
                  >
                    {item.label}
                  </span>
                </div>
                {index === 2 && (
                  <div className="mx-3 my-0.5 h-[0.5px] bg-[#DEDEDE] dark:bg-[#2A2F3A] mt-2" />
                )}
              </React.Fragment>
            );
          })}

          {/* Hand — points at the active row */}
          <img
            src={hand}
            alt=""
            className="absolute pointer-events-none select-none pointer"
            style={{
              width: HAND_SIZE,
              height: HAND_SIZE,
              top: handTop,
              right: -26,
              animation: "handTap 1.4s ease-in-out infinite",
              transformOrigin: "60% 30%",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AppNavMockup;
